import { createSlice } from "@reduxjs/toolkit";

const configSlice = createSlice({
  name: "config",
  initialState: {
    lang: "en",
    loader: false,
  },
  reducers: {
    changeLanguage: (state, action) => {
      state.lang = action.payload;
    },
    displayLoader: (state, action) => {
      state.loader = action.payload;
    },
  },
});

export const { changeLanguage, displayLoader } = configSlice.actions;

export default configSlice.reducer;
